<template>
  <div>
    <nav class="navbar navbar-transparent navbar-absolute">
      <div class="container">
        <div class="navbar-header">
          <button type="button"
                  class="navbar-toggle navbar-toggle-black"
                  @click="toggleNavbar"
                  data-toggle="collapse"
                  data-target="#navigation-example-2">
            <span class="sr-only">Toggle navigation</span>
            <span class="icon-bar "></span>
            <span class="icon-bar "></span>
            <span class="icon-bar"></span>
          </button>
        </div>
        <div class="collapse navbar-collapse">
          <ul class="nav navbar-nav navbar-right">
            <li>
              <router-link to="/login" class="btn">
                Quero Entrar
              </router-link>
            </li>
          </ul>
        </div>
      </div>
    </nav>

    <div class="wrapper wrapper-full-page">
      <div class="register-page">
        <!--   you can change the color of the filter page using: data-color="blue | azure | green | orange | red | purple" -->
        <div class="content">
          <div class="container">
            <div class="row">
              <div class="col-md-8 col-md-offset-2">
                <div class="header-text">
                  <h2><img src="static/img/logo.png" alt="Avaliação de Desempenho" class="logo_ad_r"></h2>
                  <h4>Nunca foi tão fácil realizar e solicitar uma avaliação de desempenho na Brasal.</h4>
                  <hr>
                </div>
              </div>
              <div class="col-md-4 col-md-offset-2">
                <div class="media">
                  <div class="media-left">
                    <div class="icon icon-danger">
                      <i class="ti ti-user"></i>
                    </div>
                  </div>
                  <div class="media-body">
                    <h5>Colaborador e Gestor</h5>
                    A partir de agora as avaliações de desempenho só podem ser realizadas consensualmente com seu gestor imediato.
                  </div>
                </div>
                <div class="media">
                  <div class="media-left">
                    <div class="icon icon-warning">
                      <i class="ti-reload"></i>
                    </div>
                  </div>
                  <div class="media-body">
                    <h5>Feedbacks Aleatórios</h5>
                    Você pode solicitar 2 avaliações de desempenho por ano, além da avaliação realizada normalmente em cada ciclo.
                  </div>
                </div>
                <div class="media">
                  <div class="media-left">
                    <div class="icon icon-info">
                      <i class="ti-thumb-up"></i>
                    </div>
                  </div>
                  <div class="media-body">
                    <h5>Competências</h5>
                    O colaborador tem mais clareza sobre quais são as competências em que ele está sendo avaliado pelo gestor.
                  </div>
                </div>
              </div>
              <div class="col-md-4">
                <form @submit.prevent="validForm()">
                  <div class="card card-plain">                    
                    <div class="content">
                    <p class="p_form">Caso você ainda tenha alguma dúvida preencha o formulário abaixo e entraremos em contato o mais breve possível.</p>
                      <div class="form-group">
                        <input type="text" v-model="form.name" maxlength="100" placeholder="Digite seu Nome*" class="form-control">
                      </div>
                      <div class="form-group">
                        <input type="email" v-model="form.email" maxlength="65" placeholder="Digite seu E-mail*" class="form-control" required>
                      </div>
                      <div class="form-group">
                        <input type="text" v-model="form.company" maxlength="45" placeholder="Digite sua Empresa*" class="form-control">
                      </div>
                      <div class="form-group">
                        <textarea v-model="form.message" placeholder="Qual a sua dúvida?" class="form-control" rows="3"></textarea>
                      </div>
                      <div class="text-center" :class="{'text-success': !response.error, 'text-danger': response.error }" style="margin-bottom: 10px;" v-if="!!response.message">
                        {{ response.message }}
                      </div>                     
                    </div>
                    <div class="footer text-center">
                      <button type="submit" class="btn btn-fill btn-wd "><loading-spin :check="loading" class="loading-spin-login"></loading-spin> Enviar</button>
                    </div>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>

        <footer class="footer footer-transparent">
          <div class="container">
            <div class="copyright text-center">
              <a href="https://www.brasal.com.br" target="_blank">
                 <img src="static/img/logo_brasal_c.png" alt="Brasal" class="logo_brasal">              
              </a>
            </div>
          </div>
        </footer>
      </div>
    </div>
    <div class="collapse navbar-collapse off-canvas-sidebar">
      <ul class="nav nav-mobile-menu">
        <li>
          <router-link to="/login">
            Quero Entrar
          </router-link>
        </li>
      </ul>
    </div>
  </div>
</template>
<script>
  export default {
    data () {
      return {
        form: {
          name: '',
          email: '',
          company: '',
          message: ''
        },
        response: {
          message: '',
          error: false
        },
        loading: false
      }
    },
    methods: {
      validForm () {
        if (!!this.form.name && !!this.form.email && !!this.form.company) {
          this.sendForm()
        } else {
          this.setResponse('Todo os campos (*) são obrigatórios.', true)
        }
      },
      async sendForm () {
        let url = '/support/contact'
        this.loading = true
        await axios.post(url, this.form)
        .then((res) => {
          this.setResponse(res.data.message)
          this.form = {
            name: '',
            email: '',
            company: '',
            message: ''
          }
        })
        .catch((err) => {
          let message = 'Não foi possível enviar sua mensagem, tente novamente mais tarde.'
          if (err.response.status !== 500) {
            message = res.response.data.message
          }
          this.setResponse(message, true)
        })
        this.loading = false
      },
      setResponse (message, error = false) {
        this.response.message = message
        this.response.error = error // true || false

        if (this.response.message) {
          setTimeout(() => {
            this.setResponse(null)
          }, 5000)
        }
      },
      toggleNavbar () {
        document.body.classList.toggle('nav-open')
      },
      closeMenu () {
        document.body.classList.remove('nav-open')
        document.body.classList.remove('off-canvas-sidebar')
      }
    },
    beforeDestroy () {
      this.closeMenu()
    }
  }
</script>
<style>
.logo_ad_ra{
  max-width:100% !important;
}
</style>



// WEBPACK FOOTER //
// src/components/Dashboard/Views/Pages/Support.vue